<script setup lang="ts">
// DUPLICATED/adapted from packages/frontend/src/modules/browser/components/rules/RulesDocument.vue
// for the studio preview. This is a DISPLAY-ONLY SUBSET: the document title
// is rendered as a heading; sections are rendered via RuleSectionView (editor copy).
// expandRuleDocument is called in a computed to resolve all `ref` markers (battleplans,
// battleTactics) against the bundle before rendering. Keep the expand + render loop in
// sync with the frontend original; do not re-add app-specific chrome here.
//
// Import rewiring vs original:
//   - RuleSection → ./RuleSectionView.vue (local editor copy)
//   - expandRuleDocument, BattlepackBundle, RuleDocument → @scrolldex/shared
import { computed } from 'vue';
import { expandRuleDocument, type BattlepackBundle, type RuleDocument } from '@scrolldex/shared';
import RuleSectionView from './RuleSectionView.vue';

const props = defineProps<{
  document: RuleDocument;
  bundle: BattlepackBundle;
}>();

const expanded = computed(() => expandRuleDocument(props.document, props.bundle));
</script>
<template>
  <div class="rules-document">
    <h2 class="document-title">{{ expanded.title }}</h2>
    <RuleSectionView v-for="section in expanded.sections" :key="section.name" :section="section" />
  </div>
</template>
<style scoped>
.rules-document {
  padding: var(--st-space-2) 0;
}

.document-title {
  font-size: var(--st-text-xl);
  font-weight: var(--st-weight-bold);
  color: var(--st-text);
  margin: 0 0 var(--st-space-3);
  padding-bottom: var(--st-space-2);
  border-bottom: 2px solid var(--st-accent);
}
</style>
